import "./RepairSolutions.module.css";
import Header from "@/reusable_sections/Header";
import PrecisionDiagnostics from "./sections/PrecisionDiagnostics";
import EquipmentFocus from "./sections/EquipmentFocus";
import Footer from "@/reusable_sections/Footer";
export default function RepairSolutionsPage() {
  return <div>
      <Header />
      <PrecisionDiagnostics />
      <EquipmentFocus />
      <Footer />
    </div>;
}